<template>
  <div class="auth-page" :style="clientColor ? { '--brand-color': clientColor } : null">
    <header class="top-bar">
      <div class="brand-pill" :style="{ backgroundColor: logoBackgroundColor }">
        <img v-if="clientLogo"
             :src="clientLogo"
             alt="Client Logo"
             class="brand-image" />
        <img v-else
             src="@/../public/static/img/acrew-logo-with-effects-white.png"
             alt="ACREW Logo"
             class="brand-image default" />
      </div>
      <div class="top-login">
        <img src="@/../public/static/img/acrew-dash-pattern.png" alt="" class="dash-pattern" />
        <span>Login</span>
      </div>
    </header>
    <div class="content-area" fluid>
      <div class="card-wrapper">
        <div class="auth-card">
          <div class="heading">
            <div class="heading-text">
              <h2>Forgot Password</h2>
            </div>
          </div>
          <div v-if="isSubmitting" class="loading-overlay">
            <v-progress-circular indeterminate color="primary" size="50" />
          </div>
          <v-form ref="form" @submit.prevent="submit">
            <div v-if="!submitted">
              <p>Enter your email to receive a password reset link</p>
              <v-text-field v-model="username"
                            type="email"
                            label="Email"
                            :rules="[rules.required, rules.email]"
                            validate-on-blur
                            autofocus
                            dense
                            hide-details="auto"
                            class="line-input custom-filled" />
              <v-btn class="btn-primary full-width-btn" type="submit" :disabled="isSubmitting">
                Submit
              </v-btn>
            </div>
            <div v-else>
              <h3>Your reset link has been sent!</h3>
              <p>Please follow the instructions in your email to reset your password.</p>
            </div>
          </v-form>
        </div>
      </div>
    </div>
    <div v-if="clientColor" class="powered-by">
      <span>BROUGHT TO YOU BY</span>
      <img src="@/../public/static/img/acrew-logo-with-effects.png" alt="Logo" />
    </div>
  </div>
</template>
<style scoped lang="scss">
  /** ForgotPassword.vue */
  @import '@/scss/variables.scss';
  @import '@/scss/auth/page.scss';

  .full-width-btn {
    width: 100%;
    margin-top: 5px;
  }
</style>
<script>
import DataService from '../../_services/DataService';
import ValidateService from '../../_services/ValidateService';
import { loadClientPreferences } from '../utils/UxUtils';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      clientLogo: null,
      clientColor: null,
      whiteBehindLogo: false,
      username: '',
      submitted: false,
      isSubmitting: false,
      rules: ValidateService.validators,
    };
  },
  computed: {
    logoBackgroundColor() {
      return this.whiteBehindLogo ? 'white' : (this.clientColor || '#11405c');
    },
  },
  methods: {
    async submit() {
      if (this.isSubmitting) return;
      
      if (!this.$refs.form || !this.$refs.form.validate()) {
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        const response = await DataService.sendPasswordResetEmail({ username: this.username });
        
        if (response && response.status === 200) {
          this.submitted = true;
        } else {
          this.$root.$emit('raise_alert', { color: 'error', text: response?.data || 'Failed to send reset email. Please try again.' });
        }
      } catch (error) {
        this.$root.$emit('raise_alert', { color: 'error', text: 'Network error. Please try again.' });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  async mounted() {
    try {
      this.username = this.$route.query.username ?? '';
      await loadClientPreferences(this);
    } catch (error) {
      this.$root.$emit('raise_alert', { color: 'error', text: 'Failed to initialize. Please refresh the page.' });
    }
  },
};
</script>
